import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { compose, onlyUpdateForPropTypes } from "recompose";

class InnerUIContainer extends React.Component {
  static propTypes = {
    alwaysAssumeNavIsHidden: PropTypes.bool,
    alwaysAssumeNavIsShowing: PropTypes.bool,
    children: PropTypes.node.isRequired,
    hasClickHandler: PropTypes.bool.isRequired,
    navHidden: PropTypes.bool.isRequired,
    onClick: PropTypes.func,
  };

  get isNavHidden() {
    return (
      (this.props.navHidden || this.props.alwaysAssumeNavIsHidden) &&
      !this.props.alwaysAssumeNavIsShowing
    );
  }

  render() {
    return (
      // This element will only capture bubbled up events, so don't enforce standard rules.
      // This is documented in the eslint rules https://github.com/jsx-eslint/eslint-plugin-jsx-a11y/blob/main/docs/rules/no-static-element-interactions.md#case-the-event-handler-is-only-being-used-to-capture-bubbled-events
      // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
      <div
        {...(this.props.onClick
          ? {
              "aria-label": "Start Story Modal",
              role: "button",
            }
          : null)}
        className={classnames("inner-ui-container", {
          "inner-ui-container--clickable": this.props.hasClickHandler,
          "inner-ui-container--nav-hidden": this.isNavHidden,
        })}
        onClick={this.props.onClick}
      >
        {this.props.children}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  hasClickHandler: !!ownProps.onClick,
  navHidden: state.inactivity.controls,
});

const connector = connect(mapStateToProps);

export default compose(connector, onlyUpdateForPropTypes)(InnerUIContainer);
